import React, {useEffect, useRef, useState} from "react";
import {Alert, Button, Col, Form, Modal, Row} from "react-bootstrap";
import {createBanner, getAdminAssociations, updateBanner} from "../../Api/Banners/BannersFetch";

const POSITION_OPTIONS = [
    {value: 'after_trainings', label: 'Dopo gli allenamenti'},
    {value: 'after_games', label: 'Dopo le gare'},
];

const isAdminUser = () => {
    const userData = JSON.parse(localStorage.getItem('userData') || 'null');
    return userData && userData.is_admin === 1;
};

const BannerForm = ({show, handleClose, banner, update, setUpdate, setMessage}) => {
    const isAdmin = isAdminUser();
    const [formData, setFormData] = useState({
        title: '',
        position: 'after_trainings',
        link_url: '',
        is_active: 1,
        sort_order: 0,
        starts_at: '',
        ends_at: '',
    });
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [errors, setErrors] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const fileInputRef = useRef();
    const [associationId, setAssociationId] = useState('');
    const [associations, setAssociations] = useState([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (isAdmin) {
            getAdminAssociations({setAssociations});
        }
    }, []);

    useEffect(() => {
        if (banner) {
            setFormData({
                title: banner.title || '',
                position: banner.position || 'after_trainings',
                link_url: banner.link_url || '',
                is_active: banner.is_active ? 1 : 0,
                sort_order: banner.sort_order ?? 0,
                starts_at: banner.starts_at ? banner.starts_at.substring(0, 10) : '',
                ends_at: banner.ends_at ? banner.ends_at.substring(0, 10) : '',
            });
            setImagePreview(banner.image_url || null);
            setImageFile(null);
            setAssociationId(banner.association_id ? String(banner.association_id) : '');
        } else {
            setFormData({
                title: '',
                position: 'after_trainings',
                link_url: '',
                is_active: 1,
                sort_order: 0,
                starts_at: '',
                ends_at: '',
            });
            setImagePreview(null);
            setImageFile(null);
            setAssociationId('');
        }
        setErrors(null);
    }, [banner, show]);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('title', formData.title);
        data.append('position', formData.position);
        data.append('link_url', formData.link_url);
        data.append('is_active', formData.is_active);
        data.append('sort_order', formData.sort_order);
        if (formData.starts_at) data.append('starts_at', formData.starts_at);
        if (formData.ends_at) data.append('ends_at', formData.ends_at);
        if (isAdmin && associationId) data.append('association_id', associationId);
        const file = fileInputRef.current && fileInputRef.current.files[0];
        if (file) data.append('image', file);

        if (banner) {
            updateBanner({
                bannerId: banner.id,
                formData: data,
                setIsLoading,
                setErrors,
                setMessage,
                setShow: handleClose,
                update,
                setUpdate,
            });
        } else {
            createBanner({
                formData: data,
                setIsLoading,
                setErrors,
                setMessage,
                setShow: handleClose,
                update,
                setUpdate,
            });
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size={'lg'}>
            <Modal.Header closeButton>
                <Modal.Title>{banner ? 'Modifica Banner' : 'Nuovo Banner'}</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {errors && (
                        <Alert variant={'danger'} dismissible onClose={() => setErrors(null)}>
                            {typeof errors === 'string' ? errors : JSON.stringify(errors)}
                        </Alert>
                    )}
                    <Row>
                        <Col md={6}>
                            <Form.Group className={'mb-3'}>
                                <Form.Label>Titolo *</Form.Label>
                                <Form.Control
                                    type={'text'}
                                    name={'title'}
                                    value={formData.title}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className={'mb-3'}>
                                <Form.Label>Posizione *</Form.Label>
                                <Form.Select name={'position'} value={formData.position} onChange={handleChange} required>
                                    {POSITION_OPTIONS.map(opt => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={8}>
                            <Form.Group className={'mb-3'}>
                                <Form.Label>URL Link</Form.Label>
                                <Form.Control
                                    type={'url'}
                                    name={'link_url'}
                                    value={formData.link_url}
                                    onChange={handleChange}
                                    placeholder={'https://...'}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={2}>
                            <Form.Group className={'mb-3'}>
                                <Form.Label>Ordine</Form.Label>
                                <Form.Control
                                    type={'number'}
                                    name={'sort_order'}
                                    value={formData.sort_order}
                                    onChange={handleChange}
                                    min={0}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={2} className={'d-flex align-items-end mb-3'}>
                            <Form.Check
                                type={'switch'}
                                label={'Attivo'}
                                name={'is_active'}
                                checked={formData.is_active === 1}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Group className={'mb-3'}>
                                <Form.Label>Data inizio</Form.Label>
                                <Form.Control
                                    type={'date'}
                                    name={'starts_at'}
                                    value={formData.starts_at}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className={'mb-3'}>
                                <Form.Label>Data fine</Form.Label>
                                <Form.Control
                                    type={'date'}
                                    name={'ends_at'}
                                    value={formData.ends_at}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        {isAdmin && (
                            <Col md={12}>
                                <Form.Group className={'mb-3'}>
                                    <Form.Label>Associazione <small className={'text-muted'}>(opzionale — lascia vuoto per banner globale)</small></Form.Label>
                                    <Form.Select value={associationId} onChange={(e) => setAssociationId(e.target.value)}>
                                        <option value={''}>— Globale (nessuna associazione) —</option>
                                        {associations.map(assoc => (
                                            <option key={assoc.id} value={assoc.id}>{assoc.name}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        )}
                        <Col md={12}>
                            <Form.Group className={'mb-3'}>
                                <Form.Label>Immagine {!banner && '*'}</Form.Label>
                                <Form.Control
                                    type={'file'}
                                    accept={'image/*'}
                                    ref={fileInputRef}
                                    onChange={handleFileChange}
                                    required={!banner}
                                />
                            </Form.Group>
                            {imagePreview && (
                                <div className={'mb-3'}>
                                    <img
                                        src={imagePreview}
                                        alt={'Anteprima banner'}
                                        style={{maxHeight: '150px', maxWidth: '100%', objectFit: 'contain', borderRadius: '8px', border: '1px solid #ddd'}}
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant={'secondary'} onClick={handleClose} disabled={isLoading}>
                        Annulla
                    </Button>
                    <Button type={'submit'} className={'bkg-second border-0'} disabled={isLoading}>
                        {isLoading ? 'Salvataggio...' : (banner ? 'Salva modifiche' : 'Crea Banner')}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default BannerForm;
